import React, { useState } from 'react';

const Archive = ({ carService, value, carID }) => {
    const initialCarData = {
        id: carID,
        is_archive: value ? 1 : 0,  // Initialize with int16-compatible value
    };

    const [newCar, setNewCar] = useState(initialCarData);

    const onChangeArchive = (event) => {
        const updatedCheckValue = event.target.checked ? 1 : 0;  // Convert boolean to int16 (1 or 0)

        const updatedCar = {
            ...newCar,
            is_archive: updatedCheckValue,   
        };

        setNewCar(updatedCar);

        carService.updateIsArchive(updatedCar)
            .then(response => {
                carService.fetchCars();
            })
            .catch(error => {
                console.error(error);
            });
    };

    return (
        <>            
            <input
                type="checkbox"
                checked={newCar.is_archive === 1}
                onChange={onChangeArchive}
            />
        </>
    );
};

export default Archive;
